import { polygon, area as turfArea } from "@turf/turf";
import { FormattedMessage } from "react-intl";
import { connect, useSelector } from "react-redux";

import { getSelected } from "../state/existingRasterEditsMenu";
import { getList } from "../state/layerRasterSourcesMenu";

import CollapsableSidebarStyles from "./CollapsableSidebar.module.css";
import { FormLabel } from "./FormLabel";
import RightMenuHeader from "./RightMenuHeader";
import styles from "./SelectedRasterEditInspector.module.css";

const SelectedRasterEditInspector: React.FC = () => {
  const selectedRasterEdit = useSelector(getSelected);
  const rasterSources = useSelector(getList);

  const selectedEditRaster =
    rasterSources &&
    rasterSources.find((raster) => {
      return raster.url === (selectedRasterEdit && selectedRasterEdit.raster);
    });

  const selectedEditRasterType = selectedEditRaster && selectedEditRaster.type;
  const turfPolygon = selectedRasterEdit && polygon(selectedRasterEdit.polygon.coordinates);
  const area = turfPolygon && turfArea(turfPolygon);

  return (
    <div className={`${CollapsableSidebarStyles.LeftMenu}`}>
      <RightMenuHeader
        parent={"RASTEREDIT"}
        titleElement={
          selectedEditRasterType === "dem_file" ? (
            <FormattedMessage
              id="selectedRasterEditInspector.title_dem_edit"
              defaultMessage="DEM Edit"
            />
          ) : selectedEditRasterType === "interception_file" ? (
            <FormattedMessage
              id="selectedRasterEditInspector.title_interception_edit"
              defaultMessage="Interception Edit"
            />
          ) : null
        }
      />
      <FormLabel>Details</FormLabel>

      {selectedRasterEdit ? (
        <div>
          <div className={styles.Detail}>
            <span>
              <FormattedMessage id="selectedRasterEditInspector.height" defaultMessage="Height" />
            </span>
            <span>{selectedRasterEdit.value} m</span>
          </div>
          <div className={styles.Detail}>
            <span>
              <FormattedMessage id="selectedRasterEditInspector.area" defaultMessage="Area" />
            </span>
            <span>{area && Math.round(area)} (m²)</span>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default connect(null, {})(SelectedRasterEditInspector);
